export default "__VITE_ASSET__DUAlvX9A__"